import { createSelector, createFeatureSelector } from '@ngrx/store';
import {
	railroadDetailAdapter,
	RailroadDetailsState,
	railroadDetailFeatureKey,
} from './railroad-detail.reducer';
import { railroadToRailroadForm } from '../railroad-detail.utility';

export const getRailroadDetailState = createFeatureSelector<
	RailroadDetailsState
>(railroadDetailFeatureKey);

const { selectEntities } = railroadDetailAdapter.getSelectors();

export const getLoadingStatus = createSelector(
	getRailroadDetailState,
	(state: RailroadDetailsState) => state.isLoading
);

export const getTitle = createSelector(
	getRailroadDetailState,
	(state: RailroadDetailsState) =>
		state.selectedRailroadId > 0 ? 'Edit Railroad' : 'Create Railroad'
);

export const getAllRailroadEntities = createSelector(
	getRailroadDetailState,
	selectEntities
);

export const getRailroadEntity = (id: number) =>
	createSelector(getAllRailroadEntities, (entities) => entities[id]);

export const getSelectedRailroadId = createSelector(
	getRailroadDetailState,
	(state: RailroadDetailsState) => state.selectedRailroadId
);

export const getCloseAfterSaving = createSelector(
	getRailroadDetailState,
	(state: RailroadDetailsState) => !state.shouldStayOnPage
);

export const getIsSaving = createSelector(
	getRailroadDetailState,
	(state: RailroadDetailsState) => state.isSaving
);

export const getError = createSelector(
	getRailroadDetailState,
	(state: RailroadDetailsState) => state.error
);

export const getShouldSaveButtonShake = createSelector(
	getRailroadDetailState,
	(state: RailroadDetailsState) => state.error && !state.shouldStayOnPage
);

export const getSelectedRailroad = createSelector(
	getAllRailroadEntities,
	getSelectedRailroadId,
	(railroadEntities, railroadId) => railroadEntities[railroadId]
);

export const getSelectedRailroadForm = createSelector(
	getSelectedRailroad,
	(railroad) => railroadToRailroadForm(railroad)
);

export const getDivisionsForRailroad = createSelector(
	getSelectedRailroad,
	(railroad) => (railroad ? railroad.divisions : [])
);

export const getCustomers = createSelector(
	getRailroadDetailState,
	(state) => state.customers
);

export const getRwics = createSelector(
	getRailroadDetailState,
	(state) => state.rwics
);

export const getJobs = createSelector(
	getRailroadDetailState,
	(state) => state.jobs
);
